import { action_setBoardChartContainerIdSelected, action_setBoardViewComponentInfoFull, action_setPageState } from '../../../reducers/actions/KPI/actions';
import { getBoardComponentInfoRecursiveValues } from '../../../services/sKPI/board.service';
import { enum__ComponentType, enum__ComponentType_InvertedEnum } from '../../../common/Dictionaries';
import { isNullOrEmpty, isNullUndefinedOrEmpty, treeify } from '../../../common/Helpers';
import { action_setCompareContracts_ContractFilters, action_setCompareContracts_ContractFilters_Base, action_setCompareContracts_ContractFilters_Config, action_setCompareContracts_Contratos_Base } from '../../../reducers/actions/KPI/compareContractsActions';
import { action_setExternalHome_Contracts } from '../../../reducers/actions/SITE/externalHomeActions';
import moment from 'moment';

export const getComponentDataByTypeId = async (componentFilters, objElement, componentsStructures, distinctComponents, componentsMatchResult, componentsMatch, calendarOptions, dispatch, reportMode) => {
    let componentStructure = {};

    for (const component of distinctComponents) {
        switch (component.componentTypeId) {
            case enum__ComponentType.ELEMENT_OBLIGATIONS_CONTROL:
            case enum__ComponentType.SG3_HEADER:
            case enum__ComponentType.PRODUCTS:
            case enum__ComponentType.SG3KPI_CONSOLIDATE_MONTH:
            case enum__ComponentType.CONTRACT_LAST_EDP:
            case enum__ComponentType.CONTRACT_KPI_COVERAGE:
            case enum__ComponentType.CONTRACT_SERVICES:
            case enum__ComponentType.CONTRACT_SERVICES_STATUS:
            case enum__ComponentType.ELEMENT_ROLES:
            case enum__ComponentType.ELEMENT_STADISTICS:
            case enum__ComponentType.ELEMENT_BOOK_SUMMARY:
            case enum__ComponentType.ELEMENT_LAST_MOVEMENTS:
            case enum__ComponentType.ELEMENT_KPI_COMMENT_EVENT:
            case enum__ComponentType.ELEMENT_CONTRACT_SEGMENT:
            case enum__ComponentType.ELEMENT_CONTRACT_CATEGORY:
            case enum__ComponentType.ELEMENT_CONTRACT_PORTFOLIO_SUMMARY:
            case enum__ComponentType.ELEMENT_CONTRACT_KPI_DETAIL: 
            case enum__ComponentType.ELEMENT_KPI_FTE_CHART:
            case enum__ComponentType.ELEMENT_KPI_AMOUNT:
            case enum__ComponentType.ELEMENT_KPI_FTE_TREE:
            case enum__ComponentType.ELEMENT_KPI_VARIABLE_DETAILS:
            case enum__ComponentType.ELEMENT_KPI_SUMMARY:
            case enum__ComponentType.ELEMENT_KPI_SCOPE:
            case enum__ComponentType.ELEMENT_BOOK_STATUS_SUMMARY:
            case enum__ComponentType.SG3BOOK_LIBROS:
            case enum__ComponentType.INFO_TYPETEXT:
            case enum__ComponentType.INFO_COMMENT:
            case enum__ComponentType.INFO_SIMPLE_KPI:
            case enum__ComponentType.INFO_FINANCIAL:
            case enum__ComponentType.ELEMENT_CONTRACT_EXPENSE_BALANCE:
            case enum__ComponentType.ELEMENT_CONTRACT_SERVICE_SUMMARY:
            case enum__ComponentType.ELEMENT_CONTRACT_LIST_LAST_EDP:
            case enum__ComponentType.ELEMENT_CONTRACT_EDP_COVER:
            case enum__ComponentType.OCR_CHART:
            case enum__ComponentType.OCR_CHART_GAUGE:
            case enum__ComponentType.OCR_CHART_LIST:
            case enum__ComponentType.SG3KPI_LASTOPF:
            case enum__ComponentType.SG3KPI_RADIAL:
            case enum__ComponentType.SG3KPI_RADIALOPF:
            case enum__ComponentType.SG3KPI_MONITORING:
            case enum__ComponentType.SG3KPI_CONTRACT_ADVANCE:
            case enum__ComponentType.ELEMENT_CONTRACT_EXPENSE_BALANCE_DETAIL:
            case enum__ComponentType.LIST:
            case enum__ComponentType.DS_SIMPLEDATA_PERFORMANCE:
            case enum__ComponentType.DS_SIMPLEDATA:  
            case enum__ComponentType.CONSOLIDATE_GROUP_CONSOLIDATE_OPF:
            case enum__ComponentType.CONSOLIDATE_GROUP_LIST_TO_SELECT:
            case enum__ComponentType.CONSOLIDATE_GROUP_CONSOLIDATE_CHART:              
            case enum__ComponentType.CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE:
            case enum__ComponentType.CONSOLIDATE_GROUP_CONTRACT_FILTER_AGRUPATION_SERIE:
            case enum__ComponentType.ELEMENT_CONTRACT_EDP_RESUMEN:
            case enum__ComponentType.ELEMENT_CONTRACT_EDP_DISTRIBUCION:
            case enum__ComponentType.ELEMENT_CONTRACT_EDP_PARTIDAS_TBL:
            case enum__ComponentType.ELEMENT_CONTRACT_EDP_PARTIDAS_GRAPH:
            case enum__ComponentType.ELEMENT_CONTRACT_MOTNHS:
            case enum__ComponentType.ELEMENT_CONTRACT_EDP_MONTOS_GRAPH:
            case enum__ComponentType.ELEMENT_KPI_LIST_BYROLE:
            case enum__ComponentType.ELEMENT_CONTRACT_LAST_EDP:
            case enum__ComponentType.POWERBI_COMPONENT_TABLE:
            case enum__ComponentType.ELEMENT_CONTRACT_EXCHANGE_RATE:
            case enum__ComponentType.POWERBI_COMPONENT_OCR:
            case enum__ComponentType.POWERBI_COMPONENT_KEY_KPIS:
                try {
                    const serviceResponse = await getBoardComponentInfoRecursiveValues(
                        componentFilters,
                        component.boardId,
                        component.componentTypeId,
                        objElement.hasPageElementId ? objElement.elementId : (component.elementId !== 0 ? component.elementId : null),
                        null,//DataserieId.
                        calendarOptions.value.calendarSelectorId, 
                        calendarOptions.value.periodStartDate,
                        calendarOptions.value.periodEndsDate,
                        calendarOptions.value.displayAgregationId
                    )
                    componentsMatch = componentsStructures.filter(x => x.componentTypeId === component.componentTypeId);
                    componentsMatchResult = [];
                    componentsMatch.forEach(component => {
                        componentsMatchResult.push({
                            componentConfig: component,
                            componentData: serviceResponse.data.data !== null ? serviceResponse.data.data.find(x => x.boardComponentInfoId === component.id) : null,
                        })
                    });
                    componentStructure[enum__ComponentType_InvertedEnum[component.componentTypeId]] = componentsMatchResult


                    if (component.componentTypeId === enum__ComponentType.OCR_CHART_GAUGE ||
                        component.componentTypeId === enum__ComponentType.OCR_CHART ||
                        component.componentTypeId === enum__ComponentType.OCR_CHART_LIST ||
                        component.componentTypeId === enum__ComponentType.POWERBI_COMPONENT_OCR
                    ) {
                        const dataSerieIds = (serviceResponse?.data?.data ?? []).flatMap(d =>(d.items ?? []).flatMap(item =>(item.l_dataserie ?? []).map(ds => ds.dataserieId)))

                        dispatch(action_setBoardChartContainerIdSelected({
                            containerId: component.containerId,
                            dataserieId: reportMode ? (dataSerieIds.length > 0 ? dataSerieIds[0] : null) : (dataSerieIds.length > 0 ? null : null),
                            forceOCRLoad: true,
                        }));
                    }
                } catch (error) {
                    console.log(error);
                    componentStructure[enum__ComponentType_InvertedEnum[component.componentTypeId]] = componentsMatchResult
                }
            break;
            case enum__ComponentType.INFO_CUSTOMTEXT:
                const infoCustomTexResponse = await getBoardComponentInfoRecursiveValues(
                    componentFilters,
                    component.boardId,
                    component.componentTypeId,
                    objElement.hasPageElementId ? objElement.elementId : (component.elementId !== 0 ? component.elementId : null),
                    null,
                    calendarOptions.value.calendarSelectorId, 
                    calendarOptions.value.periodStartDate, 
                    calendarOptions.value.periodEndsDate,
                    calendarOptions.value.displayAgregationId
                );
                componentsMatch = componentsStructures.filter(x => x.componentTypeId === component.componentTypeId);
                componentsMatchResult = [];
                componentsMatch.forEach(component => {
                    componentsMatchResult.push({
                        componentConfig: component,
                        componentData: infoCustomTexResponse.data.data !== null ? infoCustomTexResponse.data.data.find(x => x.boardComponentInfoId === component.id) : null,
                    })
                });
                componentStructure[enum__ComponentType_InvertedEnum[component.componentTypeId]] = componentsMatchResult
            break;
            case enum__ComponentType.ELEMENT_CONTRACT_LIST_TO_COMPARE:
                try {
                    const serviceResponse = await getBoardComponentInfoRecursiveValues(
                        componentFilters,
                        component.boardId,
                        component.componentTypeId,
                        objElement.hasPageElementId ? objElement.elementId : (component.elementId !== 0 ? component.elementId : null),
                        null,//DataserieId.
                        calendarOptions.value.calendarSelectorId, 
                        calendarOptions.value.periodStartDate, 
                        calendarOptions.value.periodEndsDate,
                        calendarOptions.value.displayAgregationId
                    )
                    componentsMatch = componentsStructures.filter(x => x.componentTypeId === component.componentTypeId);
                    componentsMatchResult = [];
                    componentsMatch.forEach(component => {
                        componentsMatchResult.push({
                            componentConfig: component,
                            componentData: serviceResponse.data.data !== null ? serviceResponse.data.data.find(x => x.boardComponentInfoId === component.id) : null,
                        })
                    });
                    componentStructure[enum__ComponentType_InvertedEnum[component.componentTypeId]] = componentsMatchResult

                    let compareFilters = {};
                    if (!isNullUndefinedOrEmpty(componentsMatchResult) && componentsMatchResult.length > 0 && !isNullUndefinedOrEmpty(componentsMatchResult[0].componentData)) {
                        for (const propiedad in componentsMatchResult[0].componentData.items) {
                            if (Array.isArray(componentsMatchResult[0].componentData.items[propiedad])) {
                                if (propiedad === 'l_contract') {
                                    compareFilters['l_filter_contractCode'] =  treeify(!isNullUndefinedOrEmpty(componentsMatchResult[0].componentData.items[propiedad]) ? componentsMatchResult[0].componentData.items[propiedad].filter(x => !isNullOrEmpty(x)).map(x => ({ id: x.id, code: x.contractCode, label: x.supplierName })) : [], 'id', null, 'children', 'code', 'label');
                                }
                                else {
                                    if (!isNullUndefinedOrEmpty(componentsMatchResult[0].componentData.items[propiedad])) {
                                        for (const subPropiedad in componentsMatchResult[0].componentData.items[propiedad]) {
                                            compareFilters[`l_filter_${componentsMatchResult[0].componentData.items[propiedad][subPropiedad].contractProp}`] =  treeify(!isNullUndefinedOrEmpty(componentsMatchResult[0].componentData.items[propiedad][subPropiedad].l_items)  ? componentsMatchResult[0].componentData.items[propiedad][subPropiedad].l_items.filter(x => !isNullOrEmpty(x)).map(x => ({ id: x, label: x }))  : [], 'id', null, 'children', null, 'label');
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else {
                        compareFilters = null;
                    }

                    dispatch(action_setCompareContracts_Contratos_Base(!isNullUndefinedOrEmpty(componentsMatchResult) && componentsMatchResult.length > 0 && !isNullUndefinedOrEmpty(componentsMatchResult[0].componentData) ?
                        componentsMatchResult[0].componentData.items.l_contract : []
                    ));
                    dispatch(action_setCompareContracts_ContractFilters_Config(componentsMatchResult[0].componentData.items.l_filters))
                    dispatch(action_setCompareContracts_ContractFilters(compareFilters))
                    dispatch(action_setCompareContracts_ContractFilters_Base(compareFilters))

                } catch (error) {
                    componentStructure[enum__ComponentType_InvertedEnum[component.componentTypeId]] = componentsMatchResult
                    dispatch(action_setCompareContracts_ContractFilters(null))
                    dispatch(action_setCompareContracts_ContractFilters_Base(null))
                }
            break;
            case enum__ComponentType.ELEMENT_KPI_CONTRACT_LIST_BYROLE:
                try {
                    const serviceResponse = await getBoardComponentInfoRecursiveValues(
                        componentFilters,
                        component.boardId,
                        component.componentTypeId,
                        objElement.hasPageElementId ? objElement.elementId : (component.elementId !== 0 ? component.elementId : null),
                        null,//DataserieId.
                        calendarOptions.value.calendarSelectorId, 
                        calendarOptions.value.periodStartDate, 
                        calendarOptions.value.periodEndsDate,
                        calendarOptions.value.displayAgregationId
                    )
                    componentsMatch = componentsStructures.filter(x => x.componentTypeId === component.componentTypeId);
                    componentsMatchResult = [];
                    componentsMatch.forEach(component => {
                        componentsMatchResult.push({
                            componentConfig: component,
                            componentData: serviceResponse.data.data !== null ? serviceResponse.data.data.find(x => x.boardComponentInfoId === component.id) : null,
                        })
                    });
                    componentStructure[enum__ComponentType_InvertedEnum[component.componentTypeId]] = componentsMatchResult

                    dispatch(action_setExternalHome_Contracts(!isNullUndefinedOrEmpty(componentsMatchResult) && componentsMatchResult.length > 0 && !isNullUndefinedOrEmpty(componentsMatchResult[0].componentData) ?
                        componentsMatchResult[0].componentData.items.l_contract : []
                    ));

                } catch (error) {
                    componentStructure[enum__ComponentType_InvertedEnum[component.componentTypeId]] = componentsMatchResult
                    dispatch(action_setCompareContracts_ContractFilters(null))
                    dispatch(action_setCompareContracts_ContractFilters_Base(null))
                }
            break;
            default:
            break;
        }
    };

    dispatch(action_setBoardViewComponentInfoFull(componentStructure))
    dispatch(action_setPageState(true));
}